export function isEmptyString(value: string | null | undefined): value is null | undefined | '' {
  return value == null || value.trim() === '';
}

/**
 * Case-insensitive string includes check
 * Similar to ~/code/ui/app/utils/string.ts stringIncludes
 */
export function stringIncludes(haystack: string, needle: string, caseSensitive = false): boolean {
  const haystackString = (haystack !== '' && haystack != null ? haystack : '').toString();
  const needleString = (needle !== '' && needle != null ? needle : '').toString();

  if (!caseSensitive) {
    return haystackString.toLowerCase().includes(needleString.toLowerCase());
  }

  return haystackString.includes(needleString);
}
